<script lang="ts">
    import { onMount } from "svelte";
    import { navigate } from "svelte-navigator";
    import type { NetworkResponse } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { locationStore } from "../../../../../store/locations";
    import { user } from "../../../../../store/stores";
    import Header from "../../../_Home/Components/Header.svelte";
    import TableRow from "./NetworkLocationTableRow.svelte";
    import TableHead from "./NetworkTableHead.svelte";

    export let network;
    let files;

    const uploadLocations = async (e: Event) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("file", files[0], "ism_inventory_202111241902.xlsx");
        // request.send(formData);

        fetch(
            "https://admin-dev.whizad.io/admin/management/import/framen?network=" +
                network,
            {
                method: "POST",
                headers: {
                    Authorization: "Bearer " + $user.token,
                },
                body: formData,
                redirect: "follow",
            }
        )
            .then((response) => response.text())
            .then((result) => alert("Import abgeschlossen"))
            .catch((error) => alert("Import fehlgeschlagen"));
    };
</script>

<div class="card-content no-padding ">
    <div class="content small-padding">
        <p class="title is-4">Datei importieren</p>
        <form on:submit={(e) => uploadLocations(e)}>
            <input
                bind:files
                type="file"
                ID="fileSelect"
                accept=".xlsx, .xls, .csv"
                name="file"
            />
            <button type="submit">Importieren</button>
        </form>
    </div>
</div>

<style>
    .full-width {
        width: 100%;
        position: relative;
    }
</style>
